export default __webpack_public_path__ + "static/media/018-colonnade.76533bea.svg";